module.exports = __webpack_public_path__ + "static/media/3_col_7.9577165e.jpg";